import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.find.js";
import { getBetaTrendApi } from '@/api/betaFolder';
var NAMES = {
  T0: '日照計漂移',
  T3B: '全場年衰減率',
  T4: '髒污損失估計',
  T11: '實際與預期發電比',
  T5B: '全場絕緣阻抗年比較',
  T8S: '全場交流電壓裕度',
  T1: '串列相對衰減',
  T2A: 'MPPT 電壓漂移',
  T13: '串列離散度',
  T2B: '變流器整體電壓偏移',
  T3A: '變流器相對發電',
  T5A: '絕緣阻抗相對下降',
  T6: '變流器溫升',
  T8: '單台交流電壓',
  T9: '同電壓區間轉換效率',
  T12A: '啟動日照門檻',
  T12B: '停機日照門檻',
  T7A: '重啟次數',
  T7B: '斷線次數',
  T7C: 'RCMU 動作次數',
  T7D: '停機次數',
  T14: '降載次數',
  T10: '區段損失率'
};
var GROUPS = [['全場', ['T0', 'T3B', 'T4', 'T11', 'T5B', 'T8S']], ['串列／MPPT', ['T1', 'T2A', 'T13']], ['變流器', ['T2B', 'T3A', 'T5A', 'T6', 'T8', 'T9', 'T12A', 'T12B']], ['事件次數', ['T7A', 'T7B', 'T7C', 'T7D', 'T14']], ['區段', ['T10']]];
var UNIT = {
  T6: '°C',
  T12A: 'kW/m²',
  T12B: 'kW/m²',
  T7A: '次',
  T7B: '次',
  T7C: '次',
  T7D: '次',
  T14: '次'
};
var LEGEND = {
  紅: '紅：已達或即將達到既有告警門檻，應優先處理',
  黃: '黃：指標持續劣化，排入巡檢',
  綠: '綠：正常',
  灰: '灰：有效資料不足，無法判定'
};
var LIGHTS = ['紅', '黃', '綠', '灰'];
var RANK = {
  紅: 3,
  黃: 2,
  綠: 1,
  灰: 0,
  '': -1
};
var SPANS = [{
  value: 26,
  text: '近 26 週'
}, {
  value: 52,
  text: '近 52 週'
}, {
  value: 0,
  text: '全期'
}];
// 鳳山資料限制（2026-10-16 三年回算）；其他案場沒有就不顯示
var SITE_NOTES = {
  FS01: ['資料限制：本案場日照計於 2026 年讀值偏低約 15～25%，且環境溫度計故障，與效率及溫度相關之項目僅供參考。', '2025-05-20 以前為舊資料來源：絕緣讀值單位為現行之 100 倍，T5B 於 2025-06～2026-05 之紅燈係單位差異所致，並非實際劣化；且當時資料約 2～3 分鐘一筆，部分日期之發電量有低估情形。', '2026-10-16 起之資料：雨天改以日照量推估（當日日照量低於近 30 日最大值之 30% 即視為雨天），與 NASA 雨量相比約僅能辨識三分之一之雨天，T4 髒污損失估計可能偏高；另無衛星日照資料，T0 日照計漂移之判定將逐步轉為資料不足。']
};
var DAY = 864e5;
var ts = function ts(d) {
  return Date.parse(d + 'T00:00:00Z');
};
var md = function md(d) {
  return d.slice(5).replace('-', '/');
};
var ymd = function ymd(t) {
  return new Date(t).toISOString().slice(0, 10);
};

/** 近 12 週最小平方法外推；回 { text, ok, line:[[t,v],[t,v]] }。不足 6 週不推估 */
function forecastOf(pts, limit, unit) {
  var n = Math.min(12, pts.length);
  if (n < 6) return null;
  var p = pts.slice(-n).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      t = _ref2[0],
      v = _ref2[1];
    return [t / DAY, v];
  });
  var mx = p.reduce(function (s, x) {
    return s + x[0];
  }, 0) / n;
  var my = p.reduce(function (s, x) {
    return s + x[1];
  }, 0) / n;
  var sxx = 0;
  var sxy = 0;
  var syy = 0;
  var _iterator = _createForOfIteratorHelper(p),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        x = _step$value[0],
        y = _step$value[1];
      sxx += Math.pow(x - mx, 2);
      sxy += (x - mx) * (y - my);
      syy += Math.pow(y - my, 2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (sxx === 0) return null;
  var slope = sxy / sxx;
  var at = function at(x) {
    return my + slope * (x - mx);
  };
  var r2 = syy === 0 ? 0 : sxy * sxy / (sxx * syy);
  var _p = _slicedToArray(p[n - 1], 2),
    xl = _p[0],
    yl = _p[1];
  var xEnd = xl + 91;
  var text;
  var ok = false;
  if (limit == null) {
    text = '本項目無固定告警門檻，僅列近 12 週斜率。';
  } else {
    var sorted = pts.map(function (x) {
      return x[1];
    }).sort(function (a, b) {
      return a - b;
    });
    var up = sorted[Math.floor(sorted.length / 2)] < limit;
    var reached = up ? yl >= limit : yl <= limit;
    var approaching = up ? slope > 0 : slope < 0;
    if (reached) text = '最新一週數值已達或超過告警門檻。';else if (!approaching) {
      text = '近 12 週趨勢未朝告警門檻方向變化。';
      ok = true;
    } else {
      var dx = (limit - at(xl)) / slope;
      if (dx <= 0) text = '近 12 週趨勢線已達或超過告警門檻，惟最新實測值尚未超過，以實測值為準。';else if (dx > 1095) {
        text = '依近 12 週線性趨勢推估，3 年內不會達到告警門檻。';
        ok = true;
      } else {
        text = "\u4F9D\u8FD1 12 \u9031\u7DDA\u6027\u8DA8\u52E2\u63A8\u4F30\uFF0C\u7D04\u65BC ".concat(ymd((xl + dx) * DAY), "\uFF08\u7D04 ").concat(Math.round(dx / 7), " \u9031\u5F8C\uFF09\u9054\u5230\u544A\u8B66\u9580\u6ABB\u3002");
        xEnd = xl + Math.max(dx, 91);
      }
    }
  }
  text += "\uFF08\u659C\u7387 ".concat((slope * 7).toFixed(2), " ").concat(unit, "\uFF0F\u9031\uFF0CR\xB2 ").concat(r2.toFixed(2)).concat(r2 < 0.3 ? '，擬合度偏低，推估僅供參考' : '', "\uFF09");
  return {
    text: text,
    ok: ok,
    line: [[xl * DAY, at(xl)], [xEnd * DAY, at(xEnd)]]
  };
}
function baseChart(yTitle) {
  return {
    chart: {
      height: 300,
      zoomType: 'x'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '12px'
      }
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: {
      title: {
        text: yTitle
      }
    },
    tooltip: {
      shared: true,
      xDateFormat: '%Y-%m-%d',
      valueDecimals: 2
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false
        },
        animation: false
      }
    }
  };
}
export default {
  name: 'TrendWeekly',
  data: function data() {
    return {
      NAMES: NAMES,
      LEGEND: LEGEND,
      SPANS: SPANS,
      roots: [],
      root: '',
      d: null,
      gridSpan: 52,
      light: '紅黃',
      sel: null,
      loading: false,
      error: '',
      listFields: [{
        key: 'status',
        label: '燈號',
        tdClass: 'tr_nowrap'
      }, {
        key: 'item',
        label: '項目',
        tdClass: 'tr_nowrap'
      }, {
        key: 'device',
        label: '設備',
        tdClass: 'tr_nowrap'
      }, {
        key: 'message',
        label: '說明與建議處置'
      }, {
        key: 'opened',
        label: '開單日',
        tdClass: 'tr_nowrap'
      }, {
        key: 'weeks',
        label: '近 12 週'
      }],
      ticketFields: [{
        key: 'name',
        label: '項目'
      }, {
        key: 'count',
        label: '開單張數',
        thClass: 'text-right',
        tdClass: 'tr_num text-right'
      }]
    };
  },
  computed: {
    lastWeek: function lastWeek() {
      return this.d.weeks[this.d.weeks.length - 1];
    },
    lastIdx: function lastIdx() {
      return this.d.weeks.length - 1;
    },
    siteNotes: function siteNotes() {
      return SITE_NOTES[this.d.site] || [];
    },
    tiles: function tiles() {
      var n = [0, 0, 0, 0];
      for (var it in this.d.grid) {
        this.d.grid[it][this.lastIdx].forEach(function (x, k) {
          return n[k] += x;
        });
      }
      var t = this.d.tickets;
      return [{
        s: '紅',
        k: '紅燈（優先處理）',
        v: n[0]
      }, {
        s: '黃',
        k: '黃燈（排入巡檢）',
        v: n[1]
      }, {
        k: '開啟中之預警單',
        v: this.d.thisWeek.filter(function (r) {
          return r.opened;
        }).length
      }, {
        k: '全期開單數（平均每週）',
        v: "".concat(t.total, "\uFF08").concat((t.total / this.d.weeks.length).toFixed(1), "\uFF09")
      }, {
        s: '灰',
        k: '灰燈（資料不足）',
        v: n[3]
      }];
    },
    gridGroups: function gridGroups() {
      var _this = this;
      return GROUPS.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          items = _ref4[1];
        return {
          name: name,
          items: items.filter(function (it) {
            return _this.d.grid[it];
          })
        };
      }).filter(function (g) {
        return g.items.length;
      });
    },
    gridWeeks: function gridWeeks() {
      var all = this.d.weeks.map(function (date, i) {
        return {
          date: date,
          i: i
        };
      });
      return this.gridSpan ? all.slice(-this.gridSpan) : all;
    },
    lightOptions: function lightOptions() {
      var _this2 = this;
      var n = function n(f) {
        return _this2.d.thisWeek.filter(f).length;
      };
      return [{
        value: '紅黃',
        text: "\u7D05\uFF0B\u9EC3\uFF08".concat(n(function (r) {
          return r.status === '紅' || r.status === '黃';
        }), "\uFF09")
      }, {
        value: '全部',
        text: "\u5168\u90E8\uFF08".concat(this.d.thisWeek.length, "\uFF09")
      }].concat(_toConsumableArray(LIGHTS.map(function (s) {
        return {
          value: s,
          text: "".concat(s, "\uFF08").concat(n(function (r) {
            return r.status === s;
          }), "\uFF09")
        };
      })));
    },
    listRows: function listRows() {
      var _this3 = this;
      return this.d.thisWeek.filter(function (r) {
        return _this3.light === '全部' || r.status === _this3.light || _this3.light === '紅黃' && (r.status === '紅' || r.status === '黃');
      }).slice().sort(function (a, b) {
        return RANK[b.status] - RANK[a.status] || a.item.localeCompare(b.item) || a.device.localeCompare(b.device);
      });
    },
    selSeries: function selSeries() {
      return this.sel && this.d.series[this.sel.item + '|' + this.sel.device];
    },
    selPts: function selPts() {
      var _this4 = this;
      return this.d.weeks.map(function (w, i) {
        return [ts(w), _this4.selSeries.level[i]];
      }).filter(function (p) {
        return p[1] != null;
      });
    },
    forecast: function forecast() {
      return forecastOf(this.selPts, this.selSeries.limit, UNIT[this.sel.item] || '%');
    },
    trendChart: function trendChart() {
      var s = this.selSeries;
      var unit = UNIT[this.sel.item] || '%';
      var c = baseChart("\u8DA8\u52E2\u503C\uFF08".concat(unit, "\uFF09"));
      c.xAxis.plotBands = this.d.weeks.map(function (w, i) {
        return [w, s.status[i]];
      }).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          st = _ref6[1];
        return st === '紅' || st === '黃';
      }).map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          w = _ref8[0],
          st = _ref8[1];
        return {
          from: ts(w) - 3.5 * DAY,
          to: ts(w) + 3.5 * DAY,
          color: st === '紅' ? 'rgba(214,69,69,.12)' : 'rgba(224,160,0,.14)'
        };
      });
      if (s.limit != null) {
        c.yAxis.plotLines = [{
          value: s.limit,
          color: '#d64545',
          dashStyle: 'Dash',
          width: 1.5,
          zIndex: 3,
          label: {
            text: "\u544A\u8B66\u9580\u6ABB ".concat(s.limit),
            align: 'right',
            style: {
              fontSize: '11px'
            }
          }
        }];
        c.yAxis.softMin = Math.min(s.limit, 0);
        c.yAxis.softMax = Math.max(s.limit, 0);
      }
      c.series = [{
        name: '每週趨勢值',
        data: this.d.weeks.map(function (w, i) {
          return [ts(w), s.level[i]];
        }),
        color: '#2a78d6',
        lineWidth: 2
      }];
      if (this.forecast) c.series.push({
        name: '近 12 週趨勢外推',
        data: this.forecast.line,
        color: '#eb6834',
        dashStyle: 'Dash',
        enableMouseTracking: false
      });
      return c;
    },
    t4Chart: function t4Chart() {
      var _this5 = this;
      var c = baseChart('髒污損失（%）');
      c.yAxis.plotLines = [{
        value: 2,
        color: '#e0a000',
        dashStyle: 'Dash',
        width: 1.5,
        zIndex: 3,
        label: {
          text: '警示線 2%',
          align: 'right',
          style: {
            fontSize: '11px'
          }
        }
      }];
      c.series = [{
        name: '髒污損失估計',
        data: this.d.weeks.map(function (w, i) {
          return [ts(w), _this5.d.t4[i][0]];
        }),
        color: '#2a78d6',
        lineWidth: 2
      }];
      return c;
    },
    ticketRows: function ticketRows() {
      var _this6 = this;
      return GROUPS.flatMap(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          items = _ref10[1];
        return items;
      }).filter(function (it) {
        return _this6.d.tickets.byItem[it];
      }).map(function (it) {
        return {
          name: "".concat(it, " ").concat(NAMES[it]),
          count: _this6.d.tickets.byItem[it]
        };
      });
    }
  },
  watch: {
    root: function root() {
      this.load();
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getBetaTrendApi();
            case 3:
              _this7.roots = _context.sent.roots.sort(function (a, b) {
                return a.length - b.length || a.localeCompare(b);
              });
              _this7.root = _this7.roots[0] || '';
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              _this7.error = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '無法讀取趨勢週報';
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  },
  methods: {
    md: md,
    load: function load() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this8.root) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _this8.loading = true;
                _this8.error = '';
                _context2.prev = 4;
                _context2.next = 7;
                return getBetaTrendApi(_this8.root);
              case 7:
                _this8.d = _context2.sent.data;
                _this8.sel = _this8.listRows.find(function (r) {
                  return _this8.d.series[r.item + '|' + r.device];
                }) || null;
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                _this8.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '無法讀取趨勢週報';
              case 14:
                _context2.prev = 14;
                _this8.loading = false;
                return _context2.finish(14);
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 11, 14, 17]]);
      }))();
    },
    cellLight: function cellLight(it, i) {
      var g = this.d.grid[it][i];
      return LIGHTS.find(function (s, k) {
        return k < 3 && g[k];
      }) || '灰';
    },
    cellCount: function cellCount(it, i) {
      var n = this.d.grid[it][i][0] + this.d.grid[it][i][1];
      return n ? n > 9 ? '9+' : n : '';
    },
    cellTitle: function cellTitle(it, w) {
      var g = this.d.grid[it][w.i];
      return "".concat(w.date, "\uFF5C").concat(it, " ").concat(NAMES[it] || '', "\uFF5C\u7D05 ").concat(g[0], "\u3001\u9EC3 ").concat(g[1], "\u3001\u7DA0 ").concat(g[2], "\u3001\u7070 ").concat(g[3]);
    },
    rowClass: function rowClass(r) {
      if (!r) return '';
      var sel = this.sel && this.sel.item === r.item && this.sel.device === r.device;
      return [this.d.series[r.item + '|' + r.device] ? 'tr_clickable' : '', sel ? 'tr_selected' : ''];
    },
    selectRow: function selectRow(r) {
      var _this9 = this;
      if (!this.d.series[r.item + '|' + r.device]) return;
      this.sel = r;
      this.$nextTick(function () {
        var _this9$$refs$chartPan;
        return (_this9$$refs$chartPan = _this9.$refs.chartPanel) === null || _this9$$refs$chartPan === void 0 ? void 0 : _this9$$refs$chartPan.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  }
};